<template>
    <div>
        <div v-for="(block, index) in blockList" :key="index">
            <m-hotspot-fun 
                v-if="block.type === BlockEnum.HOT_FUNC"
                :block="block"></m-hotspot-fun>
            <m-research-pro 
                v-else-if="block.type === BlockEnum.REASEARCH_PRO"
                :block="block"></m-research-pro>
            <m-light-spot
                v-else-if="block.type === BlockEnum.LIGHT_SPOT"
                :block="block"></m-light-spot>
            <m-activity-info
                v-else-if="block.type === BlockEnum.ACTIVITY_INFO"
                :block="block"></m-activity-info>
            <m-contact-us 
                v-else-if="block.type === BlockEnum.CONTACT_US"
                :block="block"></m-contact-us>
            <m-title-btn 
                v-else-if="block.type === BlockEnum.TITLE_BTN"
                :block="block"></m-title-btn>
            <m-news-block
                v-else-if="block.type === BlockEnum.NEWS"
                :block="block"
                :news-list="newsList"></m-news-block>
            <m-resource-block
                v-else-if="block.type === BlockEnum.RESOURCE"
                :block="block"
                :resource-list="resourceList"></m-resource-block>
            <m-custom-block
                v-else-if="block.type === BlockEnum.CUSTOM"
                :block="block"></m-custom-block>
        </div>
    </div>
</template>

<script>
import { BlockEnum } from '@/config/enum'
import MHotspotFun from '../m-blocks/hotspot-fun.vue'
import MResearchPro from '../m-blocks/research-pro.vue'
import MLightSpot from '../m-blocks/light-spot.vue'
import MActivityInfo from '../m-blocks/activity-info.vue'
import MContactUs from '../m-blocks/contact-us.vue' 
import MTitleBtn from '../m-blocks/title-btn.vue' 
import MNewsBlock from '../m-blocks/news.vue'
import MResourceBlock from '../m-blocks/resource.vue'
import MCustomBlock from '../m-blocks/custom.vue'
export default {
    name:'BlockList',                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
    components:{
        MHotspotFun,
        MResearchPro,
        MLightSpot,
        MActivityInfo,
        MContactUs,
        MTitleBtn,
        MNewsBlock,
        MResourceBlock,
        MCustomBlock
    },
    props:{
        blockList:Array, 
        newsList: Array,
        resourceList: Object
    },
    computed: {
        BlockEnum(){
            return BlockEnum
        }
    },
            
}            
</script>

<style>

</style>                                                                                                                      


// WEBPACK FOOTER //
// src/templates/m-content/block-list.vue